var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSslTrackerLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 928.94 430.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:284.94px;font-family:Roboto-Bold, Roboto;font-weight:700;}.cls-1,.cls-2,.cls-5{fill:#fff;}.cls-2{font-size:152.49px;font-family:Roboto-Light, Roboto;font-weight:300;letter-spacing:-0.04em;}.cls-3{letter-spacing:-0.02em;}.cls-4{letter-spacing:0em;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(424.31 243.76)"
  }, "SSL"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(424.31 389.06)"
  }, "T", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 85.48,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 133.8,
    y: 0
  }, "acker")), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M352.42,38.72c-60.8,23-115,5.33-157.78-31.26-43,36.46-97,54.29-158,31.26L0,63.82l.32,8.81c1.05,28.25,8.5,79.9,26.08,132.48,39.19,117.25,91,155.59,159.88,196.94l8.24,4.94,8.24-4.94c68.89-41.35,120.69-79.69,159.88-196.94,17.57-52.55,25-104.21,26.07-132.48l.33-8.81Zm5.51,54.12c-.89,24.11-7.25,68.19-22.24,113-33.44,100.05-77.64,132.75-136.42,168l-7,4.21-7-4.21c-58.79-35.29-103-68-136.42-168-15-44.86-21.35-88.93-22.25-113l-.27-7.51L57.51,63.9c52.1,19.65,98.17,4.44,134.83-26.67C228.84,68.44,275.09,83.49,327,63.9l31.25,21.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M202.4,205.13C214.68,200,237,185.77,237,149.64v-14.5H152.09v14.5c0,36.13,22.27,50.38,34.54,55.49a.8.8,0,0,1,0,1.5c-12.27,5.11-34.54,19.36-34.54,55.49v14.5h5.43L179.8,256h0l.11-.08L190,246.6c3.18-6.28,2.1-16.13,1.86-25.69-.22-8.62.77-17-2-22.6,0-.08-.1-.18-.16-.28a43.67,43.67,0,0,1-10.69-6.18,39.44,39.44,0,0,1-10.86-13.26,46.73,46.73,0,0,1-4.65-16.47,1,1,0,0,1,1.27-1l21,6.87a28.08,28.08,0,0,0,17.48,0l21-6.87a1,1,0,0,1,1.28,1,47.06,47.06,0,0,1-4.72,16.62,39.71,39.71,0,0,1-11,13.26,44,44,0,0,1-10.46,6,3.36,3.36,0,0,0-.24.38c-3.12,5.52-3.12,13.82-3.2,22.36-.09,9.59.13,19.46,3.11,25.78l32.51,30.07H237v-14.5c0-36.13-22.27-50.38-34.55-55.49A.8.8,0,0,1,202.4,205.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 145.81,
    y: 282.38,
    width: 97.41,
    height: 10.85,
    rx: 4.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 145.82,
    y: 118.23,
    width: 97.41,
    height: 10.85,
    rx: 4.98
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSslTrackerLogo);
export default __webpack_public_path__ + "static/media/SSL_tracker_logo.84f5f9b24729eb1c91ccafaad3025781.svg";
export { ForwardRef as ReactComponent };